import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { questionsQueryKeys } from './questionsQueryKeys';

const filterDefinedProperties = (obj) => {
  let result = {};

  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      let value = obj[key];

      if (value !== undefined && (!Array.isArray(value) || value.length > 0)) {
        result[key] = value;
      }
    }
  }

  return result;
};

const getQuestions = async (params, errMsg) => {
  return await request.get('/Question', params, errMsg, [], undefined, 'comma');
};

const useQuestions = (params, options) => {
  const definedParams = filterDefinedProperties(params);

  return useQuery(
    questionsQueryKeys.questions(params),
    () =>
      getQuestions(
        definedParams,
        'При загрузке списка вопросов произошла ошибка'
      ),
      {
        ...options, // Передаем пользовательские опции
        refetchInterval: 60000 , // Запрашивать данные каждую секунду
      }
  );
};

export const fetchQuestionById = async ({ questionId, queryClient }) =>
  await queryClient.fetchQuery(
    questionsQueryKeys.questionById(questionId),
    () =>
      getQuestions(
        { questionNum: questionId },
        'Не удалось загрузить обновленный вопрос'
      )
  );

export default useQuestions;
